<script setup lang="ts">
const currentYear = new Date().getFullYear();
</script>

<template>
    <span class="copyright-notice">
        <span class="copyright-notice__caption">
            © 2020-{{ currentYear }} 4people. Все права защищены
        </span>
    </span>
</template>

<style scoped lang="scss">
</style>
